/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

Swiper.use([Navigation, Autoplay]);
export function slider() {
    const articleSliderSelector = ".articles-list__mobile.swiper";
    const logoSliderSelector = ".logos__slider";
    const imageSliderSelector = ".image-slider__inner.swiper";
    const linkComponentSelector = ".link-component__container.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {
        // Articles Slider
        const ArticlesSlider = [];
        const ArticlesSliderElements = document.querySelectorAll(articleSliderSelector);
        if (ArticlesSliderElements) {
            ArticlesSliderElements.forEach(slider => {
                ArticlesSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.15,
                    spaceBetween: 10,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Logo Slider
        const logoSlider = [];
        const logoSliderElements = document.querySelectorAll(logoSliderSelector);
        if (logoSliderElements) {
            logoSliderElements.forEach(slider => {

                logoSlider.push(new Swiper(slider, {
                    speed: 3000,
                    loop: true,
                    freeMode: true,
                    allowTouchMove: false,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    autoplay: {
                        delay: 0.5,
                    },
                    breakpoints: {
                        // when window width is >= 768px
                        1440: {
                            slidesPerView: 4,
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 45,
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Image Slider
        const imageSlider = [];
        const imageSliderElements = document.querySelectorAll(imageSliderSelector);
        if (imageSliderElements) {
            imageSliderElements.forEach(slider => {

                imageSlider.push(new Swiper(slider, {
                    effect: "coverflow",
                    slidesPerView: "auto",
                    spaceBetween: 15,
                    centeredSlides: true,
                    loop: true,
                    initialSlide: 1,
                    coverflowEffect: {
                        rotate: 50,
                        stretch: 100,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .image-slider__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .image-slider__button-prev",
                    },
                    breakpoints: {
                        992: {
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

                // Link Component slider
                const linkSlider = [];
                const linkSliderElements = document.querySelectorAll(linkComponentSelector);
                if (linkSliderElements) {
                    linkSliderElements.forEach(slider => {
        
                        linkSlider.push(new Swiper(slider, {
                            slidesPerView: "auto",
                            spaceBetween: 15,
                            breakpoints: {
                                992: {
                                    spaceBetween: 45,
                                }
                            },
                            on: {
                                slideChange: () => {
                                    handleSlideChange();
                                },
                                slideChangeTransitionEnd: (swiper) => {
                                    handleSlideChangeTransitionEnd(swiper);
                                }
                            }
                        }));
                    })
                }
    }

    init();

}
